interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  schemaType?: 'WebPage' | 'Organization' | 'Service' | 'Product' | 'FAQPage' | 'ContactPage' | 'AboutPage';
}

export default function SEOHead({ title, description, keywords, canonical, schemaType = 'WebPage' }: SEOHeadProps) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: 'Suvi Digital',
    description,
  };

  if (schemaType === 'Organization') {
    schema.url = 'https://suvidigital.com';
    schema.logo = 'https://suvidigital.com/logo.png';
    schema.email = 'hernan@suvidigital.com';
    schema.telephone = '+51989307864';
  }

  if (schemaType === 'Product') {
    schema.name = 'Operturi';
    schema.brand = { '@type': 'Brand', name: 'Suvi Digital' };
  }

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </>
  );
}